<template>
  <div class="business">
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="showSuccessMsg"
    />

    <div>
      <div class="row">
        <div
          class="col-4 box-rectangle"
          v-for="doc in docsList"
          :key="doc"
        >
          <img class="document-img" @click="clickFile(doc)" :src="doc" alt />
          <div class="file-title">
            <a :href="doc" style="text-decoration: none;"><span class="add-new-document">Download Document</span></a>
          </div>
        </div>
        <!-- <div class="col-4">
              <div class="block-deductions-dash">
                <div class="center-block-add-new" @click="onPickFile()">
                  <img class="block-add-new-icon" src="@/assets/circle-cross.svg" alt />
                  <span class="add-new">Add Proof</span>
                </div>
              </div>
              <input
                type="file"
                style="display: none"
                ref="fileInput"
                accept="image/*"
                @change="onFilePicked"
              />
        </div> -->
      </div>

      <!-- <div class="row" v-if="false">
        <div class="document-new-block">
          <img src="@/assets/undraw-notify-88-a-4.svg" alt />
          <div class="no-document-message">No Documents to Show yet!</div>
          <div class="add-document-message">
            Click on ‘Add New’ to submit new documents
          </div>
          <div class="add-new-icon-document" @click="onPickFile()">
            <img src="@/assets/circle-cross.svg" alt />
            <span class="add-new">Add Proof</span>
            <input
              type="file"
              style="display: none"
              ref="fileInput"
              accept="image/*"
              @change="onFilePicked"
            />
          </div>
        </div>
      </div> -->

      <footer>
        <popup-bottom-container>
          <template slot="end">
            
          </template>
        </popup-bottom-container>
      </footer>
    </div>

    <!-- Popup -->
    <pop-up-window
        v-if="showPopupfullAttachmentShow"
        @back="showPopupfullAttachmentShow = !showPopupfullAttachmentShow"
        header="Document"
        >
          <template v-slot:content>
            <full-attachmentShow
            :docUrl="docUrl"
            @back="showPopupfullAttachmentShow = !showPopupfullAttachmentShow"
            >
            </full-attachmentShow>
         </template>
    </pop-up-window>
    <!-- End -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { get_axios_file_instance, api_variables } from "@/apis/variables.js";
import fullAttachmentShow from './fullAttachmentShow.vue';
var axios_instance = get_axios_file_instance(api_variables.SERVICE_UPLOAD_LOGO);

export default {
  name: "uploadAttachment",
  components: {
    fullAttachmentShow 
  },
  props: {
    docsList: {
      type: Array,
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      errmsg: "",
      toast: false,
      showSuccessMsg: false,
      emp_id: null,
      showActionMenu: false,
      actionTypeVar: "",
      showConfirmationMsg: false,
      showPopupfullAttachmentShow: false,
      docUrl: null,
      // modalObj: {
      //   effectiveDate: "",
      //   name: "Basic",
      //   applicableFrom: "",
      //   applicableTill: ""
      // },

      employeeDocument: [
      ],
      document: null,
      deleteIndex: null,
      documentList:this.docUrl
    };
  },
  computed: {},

  mounted() {
    this.getDocments();
    this.showSuccessMsg = false;
    //console.log("Document", this.docsList);
  },

  activated() {
    this.toast = false;
    this.errmsg = "";
    this.getDocments();
    this.showSuccessMsg = false;
    this.showConfirmationMsg = false;
  },

  methods: {
    ...mapActions({
      fetch: "dashboard/organisation/employeeDocument/fetchEmployeeByID",
      deleteEmployeeDocument:
        "dashboard/organisation/employeeDocument/deleteEmployeeDocByID",
      uploadEmployeeDocuments: "dashboard/organisation/employeeDocument/create",
    }),

    async getDocments() {
    //   try {
    //     //console.log("Inside get document");

    //     // //console.log("getdoc call ",this.emp_id);
    //     let res = await this.fetch({
    //       data: { employee_id: this.viewDocument.employee_id },
    //     });
    //     //console.log("Documents List:", res);
    //   } catch (error) {
    //     this.toast = true;
    //     this.errmsg = error;
    //   }
    },

    clickFile(doc) {
      this.showPopupfullAttachmentShow = true;
      this.docUrl = doc;
      // this.$emit("selectedAttachment");
    },

    showConfirmation(document, index) {
      //console.log(document);
      this.showConfirmationMsg = true;
      this.document = document;
      this.deleteIndex = index;
    },

    /* function to hide the confimation pop-up */
    cancelEvent() {
      this.showConfirmationMsg = false;
      this.showSuccessMsg = false;
    },

  },
};
</script>

<style lang="scss" scoped>
.add-new-document {
  width: 161px;
  height: 18px;
  margin: 3px 0 3px 6px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #37c6c0;
}
.block-deductions-dash {
  margin: 32px 0px 0px 16px;  
  border-radius: 4px;
  text-align: center;
  padding: 0px 0px 0px;
  position: relative;
  width: 313px;
  height: 290px;
  border: 2px dashed #34c0be;
  cursor: pointer;
}

.center-block-add-new {
  padding: 131px 0;
  text-align: center;
}

.block-add-new-icon {
  transform: translate(0px, 5px);
}

.document-img {
  width: 260px;
  height: 212px;
  margin: 8px;
}

.file-title {
  width: 313px;
  height: 58px;
  padding: 20px;
  margin-left: -1px;
  border-radius: 0px;
  text-align: left;
  border: solid 1px #e4e4e4;
}

.file-name {
  font-weight: bold;
  color: #444444;
}

.file-size {
  display: block;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1rem;
  letter-spacing: normal;
  color: #444444;
}

.box-rectangle {
  max-width: 313px;
  height: 291px;
  margin: 32px 0px 0px 16px;
  border-radius: 4px;
  border: solid 1px #e4e4e4;
  text-align: center;
  padding: 0px 0px 0px;
  position: relative;
}

.section-new-doc {
  cursor: pointer;
  display: inherit;
}

.add-new-document {
  width: 150px;
  height: 18px;
  margin: 3px 0 3px 6px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #37c6c0;
}

.action-section:hover {
  .action-menu {
    display: block;
  }
}
.action-section {
  display: inline-block;
  margin-left: 15px;
  text-align: center;

  img {
    width: auto;
  }

  .action-menu {
    display: none;
    top: 0%;
    left: -140px;
    right: 0;
    width: max-content;
    padding-top: 5px;
    padding-bottom: 5px;
    li {
      padding: 0px;
      font-weight: 500;
      span {
        margin: 0px 20px;
        padding: 10px;
        display: block;
      }
      &:not(:last-child) {
        span {
          border-bottom: solid 1px #979797;
        }
      }
    }
  }
}
.flex-box {
  display: flex;
  .row-container {
    margin-right: 20px;
  }
  margin-bottom: 60px;
}

.text-green {
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 600;
  color: #34c0be;
}

.margin-left-20 {
  margin: 20px 36px 0px 0px;
}

.card {
  display: flex;
  width: 25%;
  margin-right: 12px;
  height: 110px;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
  margin-left: 20px;
}

.image {
  .alignImage {
    width: 100px;
    height: 100px;
    padding: 10px 0 0 10px;
  }
}

.emp-details {
  padding: 20px 0 0 10px;
  color: #535353;
}

.Rectangle {
  width: 316px;
  height: 102px;
  opacity: 0.8;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
}

.close-card {
  cursor: pointer;
  color: #6e6e6e;
  width: 12px;
  height: 12px;
  padding: 2px 0 0 160px;
}

.bottom-75 {
  margin-bottom: 75px;
}
.text {
  width: 622px;
  height: 74px;
  font-family: Montserrat;
  font-size: 14px;
  color: #9c9c9c;
}

.content-new {
  margin: 30px 77px;
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717; // padding-top: 1px
  }
}

footer {
  height: 50px;
  flex-shrink: 0;
}

.business {
  width: 100%;
  height: 100%;
}

.business .top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}

.heading_new {
  width: auto;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}

.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.refresh-icon {
  cursor: pointer;
}

.errorr {
  border: 1px solid #e01717;
}

.errorMessage {
  color: #e01717; // padding-top: 1px
}

.selectdiv select {
  width: 300px;
  height: 35px;
  border-radius: 4px;
  outline: 0;
  font-size: 14px;
  color: black;
  border: 1px solid #a7a7a7;
  padding: 0 10px;
  /* needed */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* SVG background image */
  /* background: url("@/assets/stroke-1.png"); */
  background-size: 12px;
  background-position: calc(100% - 10px) center;
  background-repeat: no-repeat;

  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}

select .dropdown {
  border-radius: 4px;
  border: 1px solid #dadada;
  padding: 10px;
  width: 93px;
  height: 35px;
  transition: ease-in-out, width 0.35s ease-in-out;

  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}
.line {
  margin-left: 4px;
  margin-bottom: 5px;
  margin-top: 18px;
  margin-right: 30px;
  border-bottom: 1px solid #34c0be;
}

.contbtn {
  margin-top: 30px;
  float: right;
  margin-right: 30px;
  width: 154px;
  height: 45px;
  border-radius: 4px;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
  background-color: #5d409f;
  color: #ffffff;
}

.form-button {
  margin-top: 10px;
  margin-bottom: 5%;
}

.custom-width {
  width: 300px;
}

.datatable-outer-container {
  width: auto;
  table.datatable {
    width: 100%;
    border-collapse: collapse;
    margin: 0 auto;
    font-family: Montserrat;
    margin-bottom: 4px;
    //   table-layout: fixed;

    .header-row {
      background-color: white;
      height: 54px;
      th {
        background-color: #f0f1f5;
        border-bottom: 0px solid #34c0be;
        padding: 6px 8px;
        //   text-align: center;
      }
    }
    .inactiveCols {
      opacity: 0.03;
      background-color: #a2a1a1;
    }
    // for datatable2
    .Editdeleteheader {
      background-color: #ffffff;
      box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);

      th {
        // border-right: 1px solid #ececec;
        padding: 0 8px;
        // display: flex;
        span {
          border-right: 1px solid #ececec;
          padding: 0px 18px 0px 15px;
          display: inline-block;
          vertical-align: middle;
          &:first-child {
            padding: 10px 10px 7px 10px;
          }
        }
        &:last-of-type {
          text-align: right;
          span {
            border-right: none;
            font-weight: 400;
            font-style: italic;
            position: relative;
            //    display: block;
            i {
              position: absolute;
              right: 10px;
              top: 2px;
            }
          }
        }
      }
    }
    .record-row {
      height: 54px;
      border-bottom: 0px solid #d8d8d8;
      //   text-align: center;
      &:nth-child(odd) {
        background-color: #f5f6fa;
      }
      &.selectedRecord {
        background-color: #e9f9f8;
        opacity: 0.9;
      }

      td {
        padding: 6px 8px;
        color: #000000;
      }

      .action-img {
        display: block;
        cursor: pointer;
        opacity: 0.1;
      }

      &:hover {
        .action-img {
          opacity: 1;
        }
      }
    }
  }
}

.custom-input {
  border-radius: 4px;
  border: 1px solid #dadada;
  padding: 10px;
  width: 100%;
  max-width: 300px;
  height: 35px;
  -webkit-transition: ease-in-out, width 0.35s ease-in-out;
  transition: ease-in-out, width 0.35s ease-in-out;
  :focus {
    border: 1px solid #34c0be;
  }
}

.advanced-Setting {
  width: auto;
  height: 15px;
  font-family: Montserrat;
  font-size: 12px;
  color: #5d409f;
  text-decoration: underline;
  cursor: pointer;
}

.un-assign-text {
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 600;
  color: #646464;
  text-align: center;
}

.margin-top-30 {
  margin-top: 30px;
}

.margin-top-20 {
  margin-top: 20px;
}

.margin-top-10 {
  margin-top: 10px;
}

.margin-10 {
  margin: 10px;
}

.action-container {
  right: 19px;
  top: 20px;
  position: absolute;
  display: flex;
  // flex-direction: column;
  img {
    cursor: pointer;
  }
}
.action-container-icon {
  margin-left: 98%;
}

.action-menu {
  width: 128px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.23);
  background-color: #ffffff;
  margin-right: 10px;
  border-right: 20px solid #ffffff;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  .rename {
    cursor: pointer;
    // margin-left: 5px;
    font-size: 12px;
    padding: 5px 0px 5px 5px;
    color: #616363;
    width: 128px;
    // text-align: center;

    &:hover {
      border: 1px solid #c0edeb;
      // width: 120px;
      // height: 20px;
      // color:red;
      background-color: #c0edeb;
    }
  }
}

action-menu:after {
  filter: drop-shadow(1mm 0mm 0mm rgba(0, 0, 0, 0.23));
  position: absolute;
  width: 0;
  top: 0px;
  right: 5%;
  height: 0;
  content: "";
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 10px solid #ffffff;
  filter: drop-shadow(1mm 0mm 0mm rgba(0, 0, 0, 0.23));
}

.document-new-block {
  margin-left: auto;
  margin-right: auto;
  margin-top: 70px;
  width: 400px;
  text-align: center;
}

.no-document-message {
  margin: 10px 42px 10px 41px;
  font-size: 18px;
  font-weight: 600;
  color: #444444;
}

.add-document-message {
  margin: 7px 0 15px;
  font-size: 15px;
  font-weight: 500;
  color: #444444;
}

.add-new-icon-document {
  display: inline-flex;
  cursor: pointer;
}

.add-new {
  height: 18px;
  margin: 3px 0 3px 6px;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
}
</style>
